import React from "react";
import { useState, useEffect } from "react";

const TotheTop = () => {
  const [top, setTop] = useState()
  const scrollFunction = () => {
    if (
      window.scrollY > 850
    ) {
    setTop("block") 
    } else {
     setTop("none") 
    }
  }

  useEffect(() => {
    const watchScroll = () => {
      window.addEventListener("scroll",scrollFunction)
    }
  
    watchScroll()

   return () => {
    window.removeEventListener("scroll",scrollFunction)
   } 
  },[])

  return (
    <div style={{
      display: top,
    }}
    className="topBtn fixed bottom-14 right-2 z-50 outline-0 cursor-pointer p-2.5 text-4 hover:bg-red-400/50"
    onClick={() => window.scrollTo(0,500)}
    >
      <div>Top</div>
    </div>
  )

}


export default TotheTop